import { render } from "./AddNote.vue?vue&type=template&id=783253cc&scoped=true"
import script from "./AddNote.vue?vue&type=script&lang=js"
export * from "./AddNote.vue?vue&type=script&lang=js"

import "./AddNote.vue?vue&type=style&index=0&id=783253cc&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783253cc"]])

export default __exports__